import * as React from 'react';
import { Router } from 'react-static';
import { Provider } from 'react-redux';
import { ApolloProvider } from 'react-apollo';

import Layout from '../../components/Layout/Layout';
import Localization from '../Localization/Localization';
import store from './store';
import apolloClient from './apolloClient';
import Routes from './Routes';
import ServiceWorker from '../ServiceWorker/ServiceWorker';

const App: React.SFC = () => (
  <Provider store={store}>
    <ApolloProvider client={apolloClient}>
      <Router>
        <Localization>
          <ServiceWorker />
          <Layout>
            <Routes />
          </Layout>
        </Localization>
      </Router>
    </ApolloProvider>
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// /www/client/src/containers/App/App.tsx